import React from 'react';
import { Button as MuiButton } from '@material-ui/core';
import useStyles from './index.style';

const Button = ({ children, className, ...others }) => {
  const classes = useStyles();

  return (
    <MuiButton {...others} className={`${classes.baseButton} ${className}`}>
      {children}
    </MuiButton>
  );
};

export default Button;
